import { useCallback } from 'react';
import { usePresence } from './usePresence';
import { useAuth } from '../context/AuthContext';
import { logger } from '../utils/logger';

export function useOnlineUsers() {
  const { user, isAuthenticated, loading } = useAuth();
  const {
    onlineDoctors,
    onlinePatients,
    isLoading,
    error,
    refreshAll,
  } = usePresence();

  const refreshStatus = useCallback(async () => {
    logger.debug('🔄 [useOnlineUsers] Manual refresh via presence store');
    await refreshAll();
  }, [refreshAll]);

  return {
    onlineDoctors,
    onlinePatients,
    isLoading: isAuthenticated && !!user && !loading ? isLoading : false,
    hasError: error,
    refreshStatus,
  };
}

export default useOnlineUsers;
